import React, { FC } from "react";
import { FieldRenderProps } from "react-final-form";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { OperatedSwitchButton } from "../../../components/OperatedSwitchButton/OperatedSwitchButton";
import { withStyles } from "@material-ui/styles";

interface IFormInputProps extends FieldRenderProps<any> {
  additionalClassName?: string;
  disabled?: boolean;
  id?: string;
  label?: string;
}

const StyledFormControlLabel = withStyles({
  label: {
    marginLeft: 8,
  },
})(FormControlLabel);

export const FormSwitch: FC<IFormInputProps> = ({
  disabled,
  id,
  input,
  label,
  ...props
}) => {
  return (
    <StyledFormControlLabel
      control={
        <OperatedSwitchButton
          checked={props.checked}
          disabled={disabled}
          onChange={props.onChange}
        />
      }
      label={label}
      {...props}
      {...input}
    />
  );
};
